// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mlcs","top":"styles_top__13-PU","left":"styles_left__2k3Gi","description":"styles_description__1AVD_"};